

export * from './lib/whatsapp-notification-service';
